import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { createSessionTeardown } from '../lib/sessionTeardown';
import { persistor } from '../store';

const Logout = () => {
  const dispatch = useDispatch();
  const [isTeardownComplete, setIsTeardownComplete] = useState(false);

  useEffect(() => {
    let mounted = true;
    const teardownSession = createSessionTeardown({ dispatch, persistor });

    teardownSession().then(
      () => mounted && setIsTeardownComplete(true),
      () => mounted && setIsTeardownComplete(true)
    );

    return () => {
      mounted = false;
    };
  }, [dispatch]);

  if (!isTeardownComplete) return null;

  return <Navigate replace to="/login" />;
};

export default Logout;
